import { analyticsManager } from '../analytics';

/**
 * Track page view events
 * Fired when user navigates to a new page/route
 */
export const trackPageView = (pageTitle: string, pagePath?: string, referralSource?: string) => {
  try {
    analyticsManager.trackPageView({
      page_title: pageTitle,
      page_path: pagePath || window.location.pathname,
      referral_source: (referralSource || 'direct') as 'direct' | 'utm' | 'admin_link' | 'organic',
    });
  } catch (error) {
    console.error('Failed to track page view:', error);
  }
};

/**
 * Track properties list page view
 */
export const trackPropertiesListView = (filterCount?: number, totalCount?: number) => {
  trackPageView('Properties', '/properties', 'direct');
  
  if (filterCount !== undefined || totalCount !== undefined) {
    analyticsManager.trackCustomEvent('view_properties_list', {
      filter_count: filterCount || 0,
      total_count: totalCount || 0,
    });
  }
};

/**
 * Track property details page view
 */
export const trackPropertyDetailsView = (propertyId: string, propertyName?: string) => {
  trackPageView(`Property Details: ${propertyName || propertyId}`, `/properties/${propertyId}`, 'direct');
  
  analyticsManager.trackCustomEvent('view_property_details', {
    property_id: propertyId,
    property_name: propertyName,
  });
};

/**
 * Track places list page view
 */
export const trackPlacesListView = (filterCount?: number, totalCount?: number) => {
  trackPageView('Places', '/places', 'direct');
  
  if (filterCount !== undefined || totalCount !== undefined) {
    analyticsManager.trackCustomEvent('view_places_list', {
      filter_count: filterCount || 0,
      total_count: totalCount || 0,
    });
  }
};

/**
 * Track billing transactions page view
 */
export const trackBillingTransactionsView = (filterCount?: number, totalCount?: number) => {
  trackPageView('Billing - Transactions', '/billing/transactions', 'direct');
  
  if (filterCount !== undefined || totalCount !== undefined) {
    analyticsManager.trackCustomEvent('view_billing_transactions', {
      filter_count: filterCount || 0,
      total_count: totalCount || 0,
    });
  }
};

/**
 * Track billing invoices page view
 */
export const trackBillingInvoicesView = (filterCount?: number, totalCount?: number) => {
  trackPageView('Billing - Invoices', '/billing/invoices', 'direct');
  
  if (filterCount !== undefined || totalCount !== undefined) {
    analyticsManager.trackCustomEvent('view_billing_invoices', {
      filter_count: filterCount || 0,
      total_count: totalCount || 0,
    });
  }
};

/**
 * Track user profile page view
 */
export const trackProfileView = () => {
  trackPageView('User Profile', '/profile', 'direct');
};

/**
 * Track onboarding page view
 */
export const trackOnboardingView = (step?: number) => {
  trackPageView('Onboarding', '/onboarding', 'direct');
  
  if (step !== undefined) {
    analyticsManager.trackCustomEvent('onboarding_step', {
      step: step,
    });
  }
};

/**
 * Track settings page view
 */
export const trackSettingsView = () => {
  trackPageView('Settings', '/dev-settings', 'direct');
};

/**
 * Track pagination changes
 */
export const trackPaginationChange = (page: number, pageSize: number, itemCount?: number) => {
  analyticsManager.trackCustomEvent('pagination_changed', {
    page: page,
    page_size: pageSize,
    item_count: itemCount || 0,
  });
};

/**
 * Track filter application
 */
export const trackFilterApplied = (filterName: string, filterValue: string, filterCount?: number) => {
  analyticsManager.trackCustomEvent('filter_applied', {
    filter_name: filterName,
    filter_value: filterValue,
    filter_count: filterCount || 1,
  });
};

/**
 * Track search action
 */
export const trackSearch = (searchQuery: string, resultCount?: number) => {
  analyticsManager.trackCustomEvent('search', {
    search_query: searchQuery,
    result_count: resultCount || 0,
  });
};
